<template>
    <transition name="scale">
        <div class="f-alert" v-show="show">
            <div class="alert">
                <p class="f-notice">{{notice}}</p>
                <a class="f-btn f-ok" @click="confirmOk">确定</a>
                <a class="f-btn f-fail" @click="show=false">取消</a>
                <a class="f-close" @click="show=false"><img src="../assets/img/close.png" alt=""></a>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        name: "FConfirm",
        data() {
            return {
                notice: '一些提示消息',
                show: false
            }
        },
        mounted() {
            this.bus.$on('confirm', function (res) {
                this.notice = res;
                this.show = true;
            }.bind(this))
        },
        methods:{
            confirmOk(){
                this.bus.$emit('confirm-ok');
                this.show = false;
            }
        }
    }
</script>

<style scoped>
    .f-alert {
        align-items: center;
        display: flex;
        height: 100%;
        justify-content: center;
        left: 0;
        pointer-events: none;
        position: fixed;
        top: 0;
        transition: 0.2s cubic-bezier(0.25, 0.8, 0.25, 1);
        width: 100%;
        z-index: 6;
        background-color: rgba(33, 33, 33, .2);
        outline: none;
    }

    .alert {
        padding: 20px;
        box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
        border-radius: 6px;
        margin: 24px;
        text-align: center;
        font-size: 16px;
        background-color: white;
        overflow-y: auto;
        pointer-events: auto;
        transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
        z-index: inherit;
        width: 300px;
        min-height: 166px;
        position: relative;
    }
    .f-notice{
        padding: 20px 0 ;
    }
    .f-btn{
        position: absolute;
        bottom: 20px;
        display: inline-block;
        width: 120px;
        height: 40px;
        line-height: 40px;
        border: 1px solid;
        border-radius: 6px;
    }
    .f-ok
    {
        left: 20px;
        border-color: #e10078;
        background-color: #e10077;
        color: white;
    }
    .f-ok:hover{
        border-color: #ff0077;
        background-color: #ff0077;
    }
    .f-fail
    {
        right: 20px;
        border-color: #ccc;
    }
    .f-fail:hover{
        color: white;
        background-color: #ccc;
    }
    .f-close{
        position: absolute;
        top: 15px;
        right: 15px;
    }
    .scale-enter-active .alert, .scale-leave-active .alert{
        transition: all  .3s;
    }
    .scale-enter .alert, .scale-leave-to .alert{
        opacity: 0;
        transform: scale(0.5);
    }
</style>